import queryString from "query-string";
import Cookies from "universal-cookie";

const DEFAULT_OPTIONS = { path: "/" };

export const getURLQuery = () => {
  const { search } = window.location;
  return queryString.parse(search);
};

export const setCookieFromValue = (cookieName, value, options = {}) => {
  const cookies = new Cookies();
  const oldCookie = cookies.get(cookieName);
  // Remove old cookie and then replace it
  if (oldCookie) {
    cookies.remove(cookieName, DEFAULT_OPTIONS);
  }
  cookies.set(cookieName, value, { ...DEFAULT_OPTIONS, ...options });
};

export const setCookie = (cookieName, options = {}) => {
  const queries = getURLQuery();
  if (!queries[cookieName]) {
    return;
  }
  setCookieFromValue(cookieName, queries[cookieName], options);
};

export const getCookieValue = (name) => {
  const cookies = new Cookies();
  const cookie = cookies.get(name);
  return cookie;
};

export const generateCookies = (cookies) => {
  const cookiesString = cookies.map((cookie) => {
    return `${cookie}=${getCookieValue(cookie)}`;
  });
  return cookiesString.join("; ");
};
